import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { compose, branch, mapProps, withHandlers, withState, setDisplayName } from 'recompose';
var forFormik = compose(setDisplayName('behaviour(FormCompat)'), withState('isFocused', 'setFocused', false), withHandlers({
  onFocus: function onFocus(_ref) {
    var _onFocus = _ref.onFocus,
        setFocused = _ref.setFocused;
    return function (e) {
      _onFocus(e);

      setFocused(true);
    };
  },
  onBlur: function onBlur(_ref2) {
    var _onBlur = _ref2.onBlur,
        setFocused = _ref2.setFocused;
    return function (e) {
      _onBlur(e);

      setFocused(false);
    };
  }
}), mapProps(function (_ref3) {
  var meta = _ref3.meta,
      setFocused = _ref3.setFocused,
      props = _objectWithoutProperties(_ref3, ["meta", "setFocused"]);

  return _objectSpread({
    dirty: meta.touched,
    valid: !meta.error
  }, props);
}));
export default compose(branch(function (_ref4) {
  var meta = _ref4.meta;
  return meta;
}, forFormik));